import StoryblokClient from 'storyblok-js-client'

class StoryblokService {
  devMode = false
  token = process.env.STORYBLOK_ACCESS_TOKEN
  query: { [index: string]: any } = {}
  client = new StoryblokClient({
    accessToken: process.env.STORYBLOK_ACCESS_TOKEN,
    cache: {
      clear: 'auto',
      type: 'memory',
    },
  })

  getCacheVersion() {
    return this.client.cacheVersion
  }

  get(slug: string, params: any) {
    params = params || {}
    const release = this.getQuery('_storyblok_release')

    if (
      this.getQuery('_storyblok') ||
      this.devMode ||
      (typeof window !== 'undefined' && window.storyblok)
    ) {
      params.version = 'draft'

      if (release) {
        params.from_release = release
      }
    }

    if (
      typeof window !== 'undefined' &&
      typeof window.StoryblokCacheVersion !== 'undefined'
    ) {
      params.cv = window.StoryblokCacheVersion
    }

    return this.client.get(slug, params)
  }

  setQuery(query: any) {
    this.query = query
  }

  getQuery(param: string) {
    return this.query[param]
  }

  bridge() {
    if (!this.getQuery('_storyblok') && !this.devMode) {
      return ''
    }
    return (
      <script
        src={'//app.storyblok.com/f/storyblok-latest.js?t=' + this.token}
      ></script>
    )
  }

  getLayout(locale: string, uuid: string) {
    return this.get(`cdn/stories/${uuid}`, {
      resolve_relations: 'global-reference.reference',
      find_by: 'uuid',
      language: locale,
    })
  }
}

export const storyblokInstance = new StoryblokService()
